import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';
import { AvailableSites } from 'src/types/responses/available-sites';
import { fetchAvailableSites } from 'src/api/lib/site';
import { availableSitesKeys } from 'src/api/query-keys/site/available-sites.query-keys';
import { authStoreOutsideComponent } from 'src/containers/contexts/auth-provider';

export const useAvailableSites = (enabled?: boolean) => {
  const { session } = authStoreOutsideComponent();

  return useQuery<AvailableSites, ApiError>({
    queryFn: fetchAvailableSites,
    queryKey: availableSitesKeys.all,
    enabled:
      enabled === undefined
        ? !!session?.access_token
        : enabled && !!session?.access_token,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
